import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { getLocale } from "$/modules/i18n/lib/i18n";

export const Route = createFileRoute("/")({
  component: RouteComponent,
  loader: async () => {
    const locale = getLocale();

    throw redirect({
      to: "/$locale",
      params: { locale },
    });
  },
});

function RouteComponent() {
  return <Outlet />;
}
